import React from 'react'

function Gap({ width, height }) {
    return (
        <div style={{ width: width, height: height }} />
    )
}

export default Gap
